import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import app from '@/app/store'
import auth from './auth'
import tasks from './tasks'
import accounts from './accounts'
import assessmentConfigs from './assessment-configs'
import users from './users'
import companies from './companies'
import scores from '@/modules/Scores/store'
import profile from '@/modules/Profile/store'
import entitlements from '@/modules/Entitlements/store'
import assets from '@/modules/AssetManagement/store'
import bcm from '@/modules/BlueprintContentManager/store'
import clientServiceVersions from '@/store/versions'
import surveys from '@/modules/Surveys/store'

const vuexStorage = new VuexPersist({
  key: 'imbellus',
  storage: window.localStorage
})

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [vuexStorage.plugin],
  modules: {
    app,
    assets,
    bcm,
    auth,
    tasks,
    accounts,
    assessmentConfigs,
    companies,
    scores,
    profile,
    entitlements,
    clientServiceVersions,
    users,
    surveys
  }
})

export default store

/* istanbul ignore next */
if (window.Cypress) {
  window.__store__ = store
}
